namespace $.$$ {

	$mol_style_define( $shm_hitalama_version_label, {

		color: $mol_theme.shade,
		font: {
			size: '.75rem',
		},
		lineHeight: '1rem',
		minWidth: 0,
		maxWidth: '100%',
		whiteSpace: 'normal',
		overflowWrap: 'anywhere',
		textAlign: 'center',
		padding: {
			top: '.25rem',
		},
		'[outdated]': {
			true: {
				color: $shm_theme.active,
			},
		},

	} )

}
